var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAllMissing(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.034 24.723",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "all_missing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 111",
    fill: "#fb4856",
    d: "M0 0h7.997v7.997H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 411"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 407",
    fill: "#fb4856"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68",
    d: "M.001 13.079c0-.42.479-.762 1.069-.762h17.861c.591 0 1.069.342 1.069.762s-.479.76-1.069.76H1.066c-.586 0-1.065-.343-1.065-.76z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 69",
    d: "M.001 19.24c0-.42.239-.762.535-.762h8.93c.3 0 .535.342.535.762s-.239.76-.535.76H.536c-.296 0-.535-.34-.535-.76z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 70",
    d: "M.001 6.923c0-.42.479-.76 1.069-.76h17.861c.591 0 1.069.34 1.069.76s-.479.76-1.069.76H1.066C.48 7.679.001 7.339.001 6.923z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 71",
    d: "M.001.76C.001.34.48 0 1.07 0h17.861C19.522 0 20 .34 20 .76s-.479.762-1.069.762H1.066C.48 1.522.001 1.18.001.76z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 408"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 291",
    clipPath: "url(#all_missing_svg__a)",
    transform: "translate(12.036 16.725)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 528",
    d: "M7.783 6.746L5.035 4l2.748-2.749A.733.733 0 006.747.214L4 2.962 1.251.214A.733.733 0 00.215 1.251L2.962 4 .215 6.746a.733.733 0 101.036 1.037L4 5.035l2.747 2.748a.733.733 0 101.036-1.037",
    fill: "#fb4856"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllMissing);
export default ForwardRef;